'use client';

import { useState } from 'react';
import { AddToCartButton, AddToCartCounter } from '@/features/product-card/add-to-cart';
import { CartActionPlacement } from '@/features/webengage/types';
import AddToCartModal from './add-to-cart-modal';
import { useGetProductInCart } from '../_utils/use-get-product-in-cart';
import { useVariantContextValues } from '../context/use-variant-context-values';
interface Props {
  showVariantErrorHandler: () => void;
}
const PDPButton = ({
  showVariantErrorHandler
}: Props) => {
  const {
    activeVariant
  } = useVariantContextValues('pdp');
  const atpId = activeVariant?.id || '';
  const itemProposalId = activeVariant?.itemProposalId || '';
  const maxLimited = activeVariant?.limit || Infinity;
  const [showCartModal, setShowCartModal] = useState(false);
  const {
    productInCart
  } = useGetProductInCart(atpId);
  const countInCart = productInCart?.qty || 0;
  return <>
            <AddToCartModal isOpen={showCartModal} productInCart={productInCart} handleClose={() => setShowCartModal(false)} data-sentry-element="AddToCartModal" data-sentry-source-file="pdp-button.tsx" />

            {countInCart === 0 ? <AddToCartButton itemProposalId={itemProposalId} atpId={atpId} maxLimited={maxLimited} openAlsoBoughtModal={() => setShowCartModal(true)} showVariantErrorHandler={showVariantErrorHandler} type={CartActionPlacement.pdp} /> : <AddToCartCounter size='large' atpId={atpId} maxLimited={maxLimited} type={CartActionPlacement.pdp} className='w-full' />}
        </>;
};
export default PDPButton;